import { useEffect, useRef, useState } from 'react';

export default function CustomCursor() {
  const dotRef = useRef(null);
  const labelRef = useRef(null);
  const [enabled] = useState(
    () =>
      typeof window !== 'undefined' &&
      window.matchMedia('(pointer: fine)').matches &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );

  useEffect(() => {
    if (!enabled) return;
    setTimeout(() => document.documentElement.classList.add('custom-cursor-active'), 0);

    let x = -100, y = -100, rx = -100, ry = -100, scale = 1, targetScale = 1, raf;
    const dot = dotRef.current;
    const label = labelRef.current;

    const onMove = (e) => { x = e.clientX; y = e.clientY; };
    const onOver = (e) => {
      const el = e.target.closest('[data-cursor]');
      if (el) {
        label.textContent = el.dataset.cursor;
        label.style.opacity = '1';
        targetScale = 3.4;
      } else if (e.target.closest('a, button, [role="button"], input, textarea, select, label')) {
        label.style.opacity = '0';
        targetScale = 2;
      } else {
        label.style.opacity = '0';
        targetScale = 1;
      }
    };
    const loop = () => {
      rx += (x - rx) * 0.18;
      ry += (y - ry) * 0.18;
      scale += (targetScale - scale) * 0.15;
      dot.style.transform = `translate(${rx - 12}px, ${ry - 12}px) scale(${scale})`;
      raf = requestAnimationFrame(loop);
    };
    window.addEventListener('mousemove', onMove, { passive: true });
    window.addEventListener('mouseover', onOver, { passive: true });
    raf = requestAnimationFrame(loop);
    return () => {
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseover', onOver);
      cancelAnimationFrame(raf);
      document.documentElement.classList.remove('custom-cursor-active');
    };
  }, []);

  if (!enabled) return null;
  return (
    <div
      ref={dotRef}
      data-testid="custom-cursor"
      className="pointer-events-none fixed left-0 top-0 z-[200] flex h-6 w-6 items-center justify-center rounded-full border border-white/70 mix-blend-difference transition-opacity"
      style={{ background: 'rgba(255,255,255,0.08)' }}
      aria-hidden="true"
    >
      <span ref={labelRef} className="select-none whitespace-nowrap font-mono text-[3px] font-medium uppercase tracking-[0.15em] text-white opacity-0" />
    </div>
  );
}
